import { AlertTriangle, CheckCircle2, Clock, XCircle } from "lucide-react";

export default function MpesaStatusCard({ status, onClose }) {
  if (!status) return null;

  const isSuccess = status.type === "success" || status.code === "INS-0";
  const isTimeout = status.type === "pending" || status.code === "INS-9" || status.code === "PENDENTE";
  const Icon = isSuccess ? CheckCircle2 : isTimeout ? Clock : XCircle;
  const valorPago = status.amount ? `${Number(status.amount).toLocaleString("pt-MZ")} MT` : "-";
  const plano = status.plan || "Plano";
  const styles = isSuccess
    ? "border-emerald-200 bg-emerald-50 text-emerald-900"
    : isTimeout
    ? "border-amber-200 bg-amber-50 text-amber-900"
    : "border-red-200 bg-red-50 text-red-900";
  const iconStyles = isSuccess
    ? "text-emerald-600"
    : isTimeout
    ? "text-amber-600"
    : "text-red-600";

  if (isSuccess) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/40 px-4 backdrop-blur-sm">
        <div className="w-full max-w-md animate-[fadeIn_.22s_ease-out] rounded-2xl border border-emerald-100 bg-white p-6 text-slate-900 shadow-2xl">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100">
            <CheckCircle2 className="animate-bounce text-emerald-600" size={38} />
          </div>
          <h3 className="text-center text-xl font-bold">Pagamento realizado com sucesso!</h3>
          <p className="mt-2 text-center text-sm text-slate-500">
            O pagamento foi confirmado e registado no sistema.
          </p>

          <div className="mt-5 rounded-xl border border-slate-100 bg-slate-50 p-4">
            <div className="flex items-center justify-between gap-4 border-b border-slate-200 pb-3">
              <span className="text-sm text-slate-500">Valor pago</span>
              <strong className="text-lg text-slate-950">{valorPago}</strong>
            </div>
            <div className="flex items-center justify-between gap-4 pt-3">
              <span className="text-sm text-slate-500">Plano</span>
              <strong className="text-right text-sm text-slate-950">{plano}</strong>
            </div>
          </div>

          {status.reference && (
            <p className="mt-3 text-center text-xs text-slate-400">
              Referencia: {status.reference}
            </p>
          )}

          <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {status.receiptId ? (
              <a
                href={`/recibo/${status.receiptId}`}
                className="rounded-lg bg-blue-600 px-4 py-2 text-center text-sm font-semibold text-white transition hover:bg-blue-500"
              >
                Ver recibo
              </a>
            ) : (
              <a
                href="/recibos"
                className="rounded-lg bg-blue-600 px-4 py-2 text-center text-sm font-semibold text-white transition hover:bg-blue-500"
              >
                Histórico
              </a>
            )}
            {onClose && (
              <button
                type="button"
                onClick={onClose}
                className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-100"
              >
                Fechar
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`mb-4 rounded-md border p-4 shadow-sm ${styles}`}>
      <div className="flex items-start gap-3">
        <Icon className={`mt-0.5 shrink-0 ${iconStyles}`} size={24} />
        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="text-sm font-bold">
                {isSuccess ? "Pagamento confirmado" : "Pagamento nao concluido"}
              </p>
              <p className="mt-1 text-sm">{status.message}</p>
            </div>
            {onClose && (
              <button
                type="button"
                onClick={onClose}
                className="rounded border border-current px-2 py-1 text-xs font-semibold opacity-70 hover:opacity-100"
              >
                Fechar
              </button>
            )}
          </div>
          <div className="mt-3 flex items-center gap-2 text-xs opacity-80">
            <AlertTriangle size={14} />
            <span>Codigo M-Pesa: {status.code}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
